import { Injectable } from '@angular/core';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { ProductsService } from '@service/products/products.service';
import { UtilService } from '@service/util/util.service';

@Injectable({
	providedIn: 'root',
})
export class BookingAssistantService {
	constructor(
		private productsService: ProductsService,
		private utilService: UtilService,
		private accountSettings: AccountSettingsService
	) {}

	isBookingAssistantEnabled(): boolean {
		return (
			(this.productsService.BOOKING_ASSISTANT || this.accountSettings.BOOKING_ASSISTANT) &&
			(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
		);
	}
}
